import React from 'react'
import { getTrackBackground, Range } from 'react-range'

interface SingleSliderProps {
    min: number
    max: number
    step?: number
    value: number
    onChange: (value: number) => void
    disabled?: boolean
}

const SingleSlider: React.FC<SingleSliderProps> = ({
    min,
    max,
    step = 1,
    value,
    onChange,
    disabled=false
}) => {
    return (
        <Range
            values={[value]}
            step={step}
            min={min}
            disabled={disabled}
            max={max}
            onChange={(vals) => onChange(vals[0])}
            renderTrack={({ props, children }) => (
                <div
                    onMouseDown={props.onMouseDown}
                    onTouchStart={props.onTouchStart}
                    style={{
                        ...props.style,
                        height: '36px',
                        display: 'flex',
                        width: '100%',
                    }}
                >
                    <div
                        ref={props.ref}
                        style={{
                            height: '5px',
                            width: '100%',
                            borderRadius: '4px',
                            background: getTrackBackground({
                                values: [value],
                                colors: disabled ? ['#bbb', '#eee']: ['#0069AD', '#ccc'],
                                min: min,
                                max: max,
                            }),
                            alignSelf: 'center',
                        }}
                    >
                        {children}
                    </div>
                </div>
            )}
            renderThumb={({ props }) => (
                <div
                    {...props}
                    key={props.key}
                    style={{
                        ...props.style,
                    }}
                >
                    <div className="range-slider-marker">
                        <div className="range-slider-marker-value" style={{ ...(disabled ? {backgroundColor: '#e3e3e3', color: '#a3a9ad', borderColor: '#a3a9ad'} : {})}}>{value}</div>
                    </div>
                </div>
            )}
        />
    )
}

export default SingleSlider
